export enum LangKey {
  en = 'en',
  zh = 'zh',
  fr = 'fr',
  es = 'es',
  ja = 'ja',
  ko = 'ko',
  de = 'de',
}

export enum LanguageCode {
  'en-US' = 'en-US',
  'zh-CN' = 'zh-CN',
  'fr-FR' = 'fr-FR',
  'es-MX' = 'es-MX',
  'ja-JP' = 'ja-JP',
  'ko-KR' = 'ko-KR',
  'de-DE' = 'de-DE',
}

export const LanguageMapping: Record<LangKey, LanguageCode> = {
  [LangKey.en]: LanguageCode['en-US'],
  [LangKey.zh]: LanguageCode['zh-CN'],
  [LangKey.fr]: LanguageCode['fr-FR'],
  [LangKey.es]: LanguageCode['es-MX'],
  [LangKey.ja]: LanguageCode['ja-JP'],
  [LangKey.ko]: LanguageCode['ko-KR'],
  [LangKey.de]: LanguageCode['de-DE'],
};

export const NativeLanguageNames: Record<LangKey, string> = {
  [LangKey.en]: 'English',
  [LangKey.zh]: '中文',
  [LangKey.fr]: 'Français',
  [LangKey.es]: 'Español',
  [LangKey.ja]: '日本語',
  [LangKey.ko]: '한국어',
  [LangKey.de]: 'Deutsch',
};
